import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  mainTabContainer: {
    marginTop: theme.spacing(-2),
  },
  description: {
    marginTop: theme.spacing(-4),
  },
  awsImage: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  cloudImage: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
  cloudContent: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    minHeight: theme.spacing(37.5),
  },
  row: {
    display: 'flex',
    padding: theme.spacing(4, 0),
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    alignSelf: 'stretch',
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
  },
  rowItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(2),
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(0.25, 1, 0, 0),
  },
  keywordItem: {
    width: '100%',
  },
  copetitorItem: {
    width: '100%',
  },
  addKeyword: {
    marginTop: theme.spacing(2),
    width: 'fit-content',
  },
  maxLimitMessage: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
    fontStyle: 'italic',
    textAlign: 'center',
  },
  manageCompetitorBtn: {
    marginRight: theme.spacing(4),
  },
  loading: {
    height: 'auto',
    minHeight: theme.spacing(31.875),
  },
}))
